import { VisualizerProject } from "@app/shared";
import cn from "classnames";
import { emptyGuid } from "../../../../helpers";
import { InputRow, NumericInput } from "../../../shared";
import { ProjectWithData } from "../ProjectWithData";

type EditDeviceSettingsProps = {
    project: Partial<VisualizerProject>;
    maxHeight?: number;
    setProject: React.Dispatch<React.SetStateAction<Partial<ProjectWithData>>>;
};

export const EditDeviceSettings: React.FC<EditDeviceSettingsProps> = ({ project, setProject, ...props }) => {
    if ((project.id + "") === emptyGuid) {
        return <div>Invalid Project ID !</div>
    }
    return (
        <div className={cn(props.maxHeight ? `max-h-[${props.maxHeight}px]` : "", "overflow-y-auto")}>
            <InputRow>
                <NumericInput label="Device Pitch (degrees)" value={project.deviceTiltDegrees} onChange={(val) => setProject((old) => ({ ...old, deviceTiltDegrees: val }))} />
            </InputRow>
            <InputRow>
                <NumericInput label="Device Roll (degrees)" value={project.deviceRollDegrees} onChange={(val) => setProject((old) => ({ ...old, deviceRollDegrees: val }))} />
            </InputRow>
            <InputRow>
                <NumericInput label="Device Height" value={project.deviceHeight} onChange={(val) => setProject((old) => ({ ...old, deviceHeight: val }))} />
            </InputRow>
        </div>
    );
}